import React from 'react'
import { Name } from './name/Name'
import { ElementNav, Li, NavbarContainer, UlContainer } from './styles'

export const Navbar = () => {

  const ul = false

  return (
    <NavbarContainer>
      <Name name="Pablo Hernandez Vizcarra" />

      {ul
        ? <UlContainer>
            <Li><ElementNav href="">Home</ElementNav></Li>
            <Li><ElementNav href="">Skills</ElementNav></Li>
            <Li><ElementNav href="">Projects</ElementNav></Li>
            <Li><ElementNav href="">Contact me</ElementNav></Li>
          </UlContainer>
        : null
      }
    </NavbarContainer>
  )
}
